import { Button, Modal, Spinner } from '@themesberg/react-bootstrap'
import React from 'react'

const DeleteModal = ({
  showModal,
  setShowModal,
  handleDeleteYes,
  name,
  handleClose,
  showText,
  loading
}) => {
  return (
    <Modal show={showModal} onHide={() => setShowModal(false)}>

      <Modal.Body>
        <div className='fs-5'>
          Are you sure you want to delete {name || ''}?
        </div>

        {showText &&
          <>
            <hr className='mt-2 mb-3' />
            <div className='text-danger mt-2'>
              *Note: Balance bonuses applying this bonus will also be deleted.
            </div>
          </>}
      </Modal.Body>

      <Modal.Footer>
        <Button variant='outline-secondary' onClick={handleDeleteYes}>
          Yes
          {loading && (
            <Spinner
              as='span'
              animation='border'
              size='sm'
              role='status'
              aria-hidden='true'
            />
          )}
        </Button>

        <Button variant='outline-primary' onClick={handleClose}>
          No
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default DeleteModal
